import React, { useContext } from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { MatureDeviationContext } from '../../../Context/MatureDeviationContext';
import DeviationMediaService from '../../../utils/DeviationMediaService';
import { MediaSrcFile } from '../../../utils/DeviationMediaService/types';
import { getCoverImageAsBackgroundStyleProp } from '../../hooks/useDeviationCoverImage';
import { FullViewProps } from '../types';

export const PdfFullView: React.FC<FullViewProps> = ({ deviation, width, height }) => {
  const pdfFiles = DeviationMediaService.getMediaByType(deviation, 'pdf');
  if (!pdfFiles || pdfFiles.length === 0) {
    return null;
  }
  const pdfFile: MediaSrcFile = pdfFiles.pop();

  const { showBlocked } = useContext(MatureDeviationContext);
  const previewFile = DeviationMediaService.getDeviationFile(deviation, 'preview');
  const consistent_devpage_blur = useFlag('consistent_devpage_blur');
  if (showBlocked && consistent_devpage_blur && previewFile) {
    // show the blurred preview/poster if backend is showing the mature block
    return (
      <div style={{
        ...getCoverImageAsBackgroundStyleProp(previewFile.src),
        backgroundSize: 'contain',
        height: '100%',
      }} />
    );
  }

  return (
    <>
      <head>
        <link rel="preload" href={pdfFile.src} as="object" />
      </head>
      <object
        aria-label={deviation.title}
        data={pdfFile.src}
        style={{ width, height }}
        type="application/pdf"
      />
    </>
  );
};

export default PdfFullView;
